import _ from '@/utils/lodash-optimized'
import React from 'react'

import { Section } from './Report/Section'

export default class EncounterSnapshot extends React.Component {
  constructor (props) {
    super(props)
    this.renderPrefixedSections = this.renderPrefixedSections.bind(this)
  }

  renderPrefixedSections (prefix) {
    const { snapshot } = this.props
    const keys = Object.keys(snapshot).filter(item =>
      item.startsWith(`${prefix}-`))
    return (
      <div>
        {keys.map(item => (
          <Section
            key={item}
            snapshot={snapshot}
            sectionId={item}
          />
        ))}
      </div>
    )
  }

  render () {
    const { snapshot } = this.props

    if (_.isNil(snapshot)) {
      return null
    }

    return (
      <div className='encounter-snapshot'>
        <h2>Patient Summary</h2>
        <Section
          snapshot={snapshot}
          sectionId='patient'
        />
        <Section
          snapshot={snapshot}
          sectionId='medications'
        />
        <Section
          snapshot={snapshot}
          sectionId='immunizations'
        />
        <Section
          snapshot={snapshot}
          sectionId='allergies'
        />
        <Section
          snapshot={snapshot}
          sectionId='medicalhistory'
        />
        <Section
          snapshot={snapshot}
          sectionId='insurance'
        />
        <Section
          snapshot={snapshot}
          sectionId='home-assessment-safe'
        />
        <Section
          snapshot={snapshot}
          sectionId='home-assessment-daily'
        />
        <Section
          snapshot={snapshot}
          sectionId='home-assessment-dmr'
        />
        {this.renderPrefixedSections('family-support')}
        <Section
          snapshot={snapshot}
          sectionId='organizations'
        />
        <Section
          snapshot={snapshot}
          sectionId='diagnoses'
        />
        <Section
          snapshot={snapshot}
          sectionId='esas'
        />
        <Section
          snapshot={snapshot}
          sectionId='ros'
        />
        <Section
          snapshot={snapshot}
          sectionId='pe'
        />
        <Section
          snapshot={snapshot}
          sectionId='resources'
        />
        <Section
          snapshot={snapshot}
          sectionId='lifestyle'
        />
        <Section
          snapshot={snapshot}
          sectionId='vitals'
        />
        <Section
          snapshot={snapshot}
          sectionId='goals'
        />
        <Section
          snapshot={snapshot}
          sectionId='goals-and-expectations-choices-documents'
        />
        <Section
          snapshot={snapshot}
          sectionId='goals-and-expectations-choices-attorneys'
        />
        {this.renderPrefixedSections('expectations')}
        {this.renderPrefixedSections('diagnostics')}
        {this.renderPrefixedSections('igao')}
      </div>
    )
  }
}
